import {Diy1Discover} from "../../features/diy/Diy1Discover"

export default Diy1Discover.Page